import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from '../../../quiz/components/skincare/skincare_main_concern/SkincareMainConcern.module.sass';
import Button from '../../../ui_kit/button/Button';
import CONCERNS from '../../constants/concerns';
import BackButton from '../../../quiz/components/back_button/BackButton';
import Concern from '../../../quiz/components/skincare/skincare_main_concern/concern/Concern';

const MAX_CONCERNS_COUNT = 3;

function SkinConcerns(props) {
  const {
    increaseStep, decreaseStep, regimen, step,
    skincareProducts, boughtProductIds, allProducts, productsTaggings,
  } = props;

  const [concerns, setConcerns] = useState(regimen.concerns);

  const [loading, setLoading] = useState(false);

  const onNextClick = () => {
    if (Object.values(skincareProducts).length === 0
      || boughtProductIds === null
      || allProducts.length === 0
      || Object.keys(productsTaggings).length === 0) {
      setLoading(true);
      return;
    }

    increaseStep({ ...regimen, concerns });
  };

  useEffect(() => {
    if (loading) {
      onNextClick();
    }
  }, [
    Object.values(skincareProducts).length === 0,
    boughtProductIds === null,
    allProducts.length === 0,
    Object.keys(productsTaggings).length === 0,
  ]);

  const onConcernClicked = (newConcern) => {
    if (concerns.includes(newConcern)) {
      setConcerns(concerns.filter((concern) => concern !== newConcern));
    } else if (concerns.length < MAX_CONCERNS_COUNT) {
      setConcerns([...concerns, newConcern]);
    }
  };

  const color = '#CFDEB7';

  return (
    <div className={styles['main-concern']}>
      <div className={styles.content}>
        <BackButton decreaseStep={() => { decreaseStep({ ...regimen, concerns }); }} />
        {step}
        <h1 className={styles.title}>
          What are your main skin concerns?
        </h1>
        <div className={styles.description}>
          {`Select up to ${MAX_CONCERNS_COUNT}`}
        </div>
        <div className={styles.concerns}>
          {CONCERNS.map((concern) => (
            <Concern
              onClick={() => { onConcernClicked(concern); }}
              key={concern}
              concern={concern}
              isActive={concerns.includes(concern)}
              color={color}
            />
          ))}
        </div>
        <Button
          className={styles.button}
          onClickHandler={onNextClick}
          disabled={concerns.length === 0}
          loading={loading}
          text="NEXT"
          color="green"
          size="small"
        />
      </div>
    </div>
  );
}

SkinConcerns.propTypes = {
  increaseStep: PropTypes.func.isRequired,
  decreaseStep: PropTypes.func.isRequired,
  regimen: PropTypes.shape({
    concerns: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  step: PropTypes.node.isRequired,
  skincareProducts: PropTypes.shape({}).isRequired,
  boughtProductIds: PropTypes.arrayOf(PropTypes.number),
  allProducts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  productsTaggings: PropTypes.shape({}).isRequired,
};

SkinConcerns.defaultProps = {
  boughtProductIds: null,
};

export default SkinConcerns;
